import FaqSection from "@/components/v2/molecules/landing/home/FaqSection";
import FeaturedPropertiesSection from "@/components/v2/organisms/landing/home/FeaturedPropertiesSection";
import HowItWorksSection from "@/components/v2/molecules/landing/home/HowItWorksSection";
import PropertyOwnerSection from "@/components/v2/molecules/landing/home/PropertyOwnerSection";
import ReviewsSection from "@/components/v2/organisms/landing/home/ReviewsSection";
import Layout from "@/components/v2/organisms/landing/layout/Layout";
import SEOHead from "@/components/SEOHead";
import HomeStats from "@/components/v2/molecules/landing/home/HomeStats";
import HomeHeader from "@/components/v2/organisms/landing/home/HomeHeader";
import { memo } from "react";

const Home = memo(() => (
  <Layout>
    <SEOHead
      title="Alojamientos en Manzanillo Colima | Hospedaje y Departamentos | Estancia Corta"
      description="Encuentra los mejores alojamientos en Manzanillo, Colima. Departamentos y hospedajes de calidad, bonitos y a buen precio. Reserva directa con super anfitriones. ¡Tu hogar en Manzanillo!"
      canonicalUrl="https://estanciacorta.com/"
    />
    <HomeHeader />
    <HomeStats />
    <FeaturedPropertiesSection />
    <HowItWorksSection />
    <ReviewsSection />
    <FaqSection />
    <PropertyOwnerSection />
  </Layout>
));

Home.displayName = "Home";

export default Home;
